(function () {
  angular.module("akitabox.ui.dialogs.qrCode.manualEntry", [
    "ngMaterial",
    "akitabox.core.services.qrcode",
  ]);
})();
